import React from 'react';

const FACE_PATHS = [
  'M9 21c1.3-2.4 3.5-3.6 6-3.6s4.7 1.2 6 3.6',
  'M9.5 20.2c1.2-1.4 3-2.1 5.5-2.1s4.3.7 5.5 2.1',
  'M9.5 19.5h11',
  'M9 18c1.3 2 3.5 3 6 3s4.7-1 6-3',
  'M8.5 17.4c1.5 2.8 3.9 4.2 6.5 4.2s5-1.4 6.5-4.2',
];

export function Face({ i }: { i: number }) {
  return (
    <svg width="24" height="24" viewBox="0 0 30 30" fill="none">
      <circle cx="15" cy="15" r="12.2" stroke="currentColor" strokeWidth="1.6" />
      <circle cx="10.8" cy="12.2" r="1.35" fill="currentColor" />
      <circle cx="19.2" cy="12.2" r="1.35" fill="currentColor" />
      <path d={FACE_PATHS[i]} stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
    </svg>
  );
}

export function XIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M6 6l12 12M18 6L6 18" />
    </svg>
  );
}

export function CheckIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M5 13l4 4L19 7" />
    </svg>
  );
}
